export const ROLE_CODES = {
  DISPATCHER: '1',
  ROOM_SERVICE: '4',
  SUPPLIER: '5',
} as const;

export type RoleCode = (typeof ROLE_CODES)[keyof typeof ROLE_CODES];

export type Role = 'dispatcher' | 'roomService' | 'supplier' | 'unknown';

export const roleFromCode = (code: string | null): Role => {
  switch (code) {
    case ROLE_CODES.DISPATCHER:
      return 'dispatcher';
    case ROLE_CODES.ROOM_SERVICE:
      return 'roomService';
    case ROLE_CODES.SUPPLIER:
      return 'supplier';
    default:
      return 'unknown';
  }
};

export const isDispatcher = (role: Role): boolean => role === 'dispatcher';
export const isRoomService = (role: Role): boolean => role === 'roomService';
export const isSupplier = (role: Role): boolean => role === 'supplier';

/** Supplier has read-only-ish access: no archive button, no toggle, no delete, no new order. */
export const canCreateOrders = (role: Role): boolean => role !== 'supplier';
export const canDeleteOrders = (role: Role): boolean => role !== 'supplier';
export const canViewArchive = (role: Role): boolean => role !== 'supplier';
export const canToggleDelivery = (role: Role): boolean => role !== 'supplier';

/** Room service shows 3 columns (no IN_DELIVERY), no phone column, "Стая X" addresses. */
export const showsDeliveryColumn = (role: Role): boolean => role !== 'roomService';
export const showsPhoneColumn = (role: Role): boolean => role !== 'roomService';
